import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons/index';
import popupHOC from './popupHOC';

export default function bulletsMenuHOC (WrappedComponent) {
  class BulletsMenu extends Component {
    render () {
      const { isOpen, toggleMenu } = this.props;
      return (
        <div className='position-relative'>
          <button className='bullets' onClick={toggleMenu}>
            <FontAwesomeIcon icon={faEllipsisH} size='lg' />
          </button>
          { isOpen && (
            <WrappedComponent {...this.props} />
          )}
        </div>
      );
    }
  }
  return popupHOC(BulletsMenu);
}



// WEBPACK FOOTER //
// ./src/components/common/bulletsMenuHOC.js